import { Component, ViewChild, OnInit } from '@angular/core';
import { FunctionContactService, FunctionService, ContactService } from '../../../camtl.service';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { Contact } from '../../../../../shared/model';
import { Observable } from 'rxjs/Observable';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'camtl-admin-contacts',
  templateUrl: './camtl-admin-contacts.component.html',
  // styleUrls: ['./camtl-admin-contacts.component.scss'],

  host: { 'class': 'router-outlet' },
})

export class CamtlAdminContactsComponent extends BaseGridTemplate implements OnInit {
  @ViewChild('combo', { static: true }) public combo: ComboBoxComponent;

  constructor(
    private contactService: ContactService,
    private functionContactService: FunctionContactService,
    public functionService: FunctionService,
    private formBuilder: FormBuilder,
    private cgpAlertDialogService: CgpAlertDialogService
  ) {
    super();
  }

  system = {};
  functions: Array<Contact>;
  selectedFunction: any = undefined;


  ngOnInit() {
    this.functionService.query();
  }


  setModelHandler(): void {
    this.editDataItem = new Contact();
    this.editForm.removeControl("IsActive");
  }


  handleValueChange(e: any) {
    this.selectedFunction = e;
    this.template.fileName = this.selectedFunction.Description + ".xlsx"
  }


  handleFilter(value: any) {
    this.functions = this.functionService.data
      .filter((s) => {
        return s.Description.toLowerCase()
          .indexOf(value.toLowerCase()) !== -1;
      })
  }


  handleRead = () => {
    return this.selectedFunction ?
      this.functionContactService.read('/' + this.selectedFunction.Id, true) :
      Promise.resolve([]);
  }


  handleEdit = (dataItem, isDetailRow) => {
    var self = this;
    this.editForm.addControl("IsActive", new FormControl(false));
    this.contactService.read('/' + dataItem.ContactId, true)
      .then(function (response) {
        response["IsActive"] = dataItem.IsActive;
        self.editDataItem = response;
      });
  }


  handleSave = (dataItem, isNew) => {
    if (isNew) {
      dataItem.FunctionIds = [this.selectedFunction.Id];
      return this.contactService.save(dataItem, isNew);
    }
    return this.contactService.save(JSON.stringify(dataItem.IsActive), isNew, "/" + dataItem.Id + "/Function/" + this.selectedFunction.Id + "?active=" + dataItem.IsActive)
      .then(() => this.editDataItem = undefined);

  }

  disableToolbar = (controlName: string) => {
    let isDisabled: boolean = false;
    if ((!this.selectedFunction && controlName === "add") || (!this.selectedFunction && controlName === "excel")) {
      isDisabled = true;
    }
    return isDisabled;
  }

  editForm = this.formBuilder.group({
    Id: [],
    GMIN: ["", Validators.required],
    FirstName: [],
    LastName: [],
    Email: [],
    IsActive: [],
    FunctionIds: [],
    CreatedBy: [],
    CreatedDate: [],
  })

  columns = [
    {
      field: "ContactName",
      title: "Contact Name",
    }, {
      field: "EmailAddress",
      title: "Contact Email",
      template: {
        type: 'email',
      }
    }, {
      field: "Required",
      title: "Required Function",
      width: 170,
      template: {
        type: "boolean",
        onLabel: "Yes",
        offLabel: "No"
      }
    }, {
      field: "IsActive",
      title: "Status",
      width: 170,
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    }
  ]


  template = {
    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
      width: 55,
      isDisabled: this.disableToolbar
    },
    columns: this.columns,
    view: this.functionContactService,
    service: [],
    read: this.handleRead,
    edit: this.handleEdit,
    save: this.handleSave,
    fileName: "contacts.xlsx"
  }


  formDialog = {
    title: "Contact",
    formControls: [
      {
        type: "person",
        name: "GMIN",
        title: "GMIN/GMID",
        service: this.contactService,
      },
      {
        type: "boolean",
        name: "IsActive",
        title: "Active",
      }
    ],
    service: this.contactService
  }
}
